import { render, staticRenderFns } from "./editTenant.vue?vue&type=template&id=50debaf5&scoped=true"
import script from "./editTenant.vue?vue&type=script&lang=js"
export * from "./editTenant.vue?vue&type=script&lang=js"
import style0 from "./editTenant.vue?vue&type=style&index=0&id=50debaf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50debaf5",
  null
  
)

export default component.exports